/***
 * Created on 2024/3/29
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect} from 'react';
import {useCountdown} from "../../hook/countdown";

function QnapAuthAppTimer({start, init_time, class_name, endAction}) {

    const {seconds, setSeconds} = useCountdown(init_time);

    const showTimeleft = () => {
        if (seconds <= 59) {
            if (seconds < 0) return '0:00';
            return `0:${String(seconds).padStart(2, '0')}`;
        }
        else {
            return `${Math.floor(seconds/60)}:${String(seconds%60).padStart(2, '0')}`;
        }
    }

    useEffect(() => {
        setSeconds(parseInt(init_time));

    }, [start, init_time]);

    useEffect(() => {
       if (seconds !== undefined && seconds <= 0) {
           endAction();
       }

    }, [seconds]);

    return (
        <div className={class_name}>{showTimeleft()}</div>
    );
}

export default QnapAuthAppTimer;